import { ICommentDataset } from 'constants/types/webinar.types'
import { IObj } from 'constants/types/common.types'

const sortByCreatedAt = (data?: ICommentDataset[]) => {
  if (data) {
    return data.sort((a, b) => {
      if (a._id > b._id) return 1
      if (a._id < b._id) return -1
      return 0
    })
    // return data.sort((a, b) => {
    //   const dateA: any = new Date(a.createdAt),
    //     dateB: any = new Date(b.createdAt)

    //   return dateA - dateB
    // })
  }
}

const formatComments = (data: ICommentDataset[]): [ICommentDataset[], number] => {
  sortByCreatedAt(data)
  const commentById = {} as IObj<ICommentDataset>
  const stages = { first: [] as ICommentDataset[], second: [] as ICommentDataset[] }
  data.forEach((comment: ICommentDataset) => {
    commentById[String(comment._id)] = comment
    comment.answers = []
    stages[!comment.answerTo ? 'first' : 'second'].push(comment)
  })
  let COUNT = stages.first.length
  stages.second.forEach((secondItem) => {
    const firstItem = commentById[String(secondItem.answerTo || 'unk')]
    if (firstItem) {
      COUNT++
      // firstItem.answers = firstItem.answers || []
      firstItem.answers?.push(secondItem)
    }
  })
  return [stages.first, COUNT]
}

const resizeTexarea = (el: HTMLTextAreaElement) => {
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
}

export { sortByCreatedAt, formatComments, resizeTexarea }
